module.exports = __webpack_public_path__ + "static/img/bg_13.96ba2f14.png";